import styled, { css } from 'styled-components';

import { DataGrid, Text18SB } from '@sternum/ui';
import { LinkTo } from '@sternum/web/components/LinkTo';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const DataGridStyled = styled(DataGrid)<{ $shouldCenterContent?: boolean }>`
  ${({ $shouldCenterContent }) =>
    $shouldCenterContent &&
    css`
      display: flex;
      flex-direction: column;
      height: 100%;
    `}
`;

export const HeadStyled = styled(DataGrid.Head)`
  min-width: fit-content;
  z-index: 1;
  border-radius: 0;
`;

export const HeadRowStyled = styled(DataGrid.HeadRow)`
  border-bottom: 1px solid ${ct({ Dark: Colors.Lighter, Light: Colors.Lighter })};
`;

export const RowStyled = styled(DataGrid.Row)<{ $isLastItem: boolean }>`
  min-width: fit-content;
  align-items: center;
  border-bottom: 1px solid ${ct({ Dark: Colors.Lighter, Light: Colors.Lighter })};

  &:hover {
    background-color: ${Colors.Lighter};
  }

  ${(props) =>
    props.$isLastItem &&
    css`
      border-bottom: none;
    `}
`;

export const RowLink = styled(LinkTo)`
  grid-template-columns: inherit;
`;

export const CellStyled = styled(DataGrid.Cell)`
  font-size: 12px;
  overflow: hidden;
`;

export const headCellCss = css`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
`;

export const StyledHeaderText = styled.span`
  text-wrap: nowrap;
  font-size: 10px;
`;

export const NoItems = styled(Text18SB)`
  display: grid;
  place-items: center;
  height: 100%;
  color: ${ct({ Light: Colors.GreyDarker, Dark: Colors.GreyDarker })};
`;
